const hook = {
    missing_events: '최소한 하나의 이벤트를 제공해야 합니다.',
    send_test_payload_failed: '테스트 페이로드 보내기 실패: {{message}}',
    endpoint_responded_with_error: '엔드포인트가 오류로 응답했습니다.',
};
export default Object.freeze(hook);
